<template>
  <div>
    <div class="control">
      <select v-model="selectedCategoryId" required>
        <option value="-1" selected disabled>Seleccionar categoría</option>
        <option v-for="c in availableCategories" :key="c.id" :value="c.id">{{ c.name }}</option>
      </select>
    </div>

    <div class="control">
      <select v-model="selectedPlanId" required :disabled="selectedCategoryId == -1">
        <option value="-1" selected disabled>Seleccionar grupo</option>
        <option v-for="p in availablePlans" :key="p.id" :value="p.id">{{ p.name }}</option>
      </select>
    </div>

    <div class="control">
      <select v-model="selectedActionId" required :disabled="selectedPlanId == -1">
        <option value="-1" selected disabled>Seleccionar atención</option>
        <option v-for="a in availableActions" :key="a.id" :value="a.id">{{ a.name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag"
import POSSIBLE_ATTENTION_TREE from "./graphql/PossibleAttentionTree.gql"

export default {
  name: "AttentionTree",
  data() {
    return {
      selectedCategoryId: -1,
      selectedPlanId: -1,
      selectedActionId: -1,
      tree: {
        categories: [],
        plans: [],
        actions: []
      }
    }
  },

  apollo: {
    possibleAttentionTree: {
      query: POSSIBLE_ATTENTION_TREE,
      variables() {
        return {
          conditions: {
            // no conditions for now, maybe add the student in the future
          }
        }
      },
      update(data) {
        this.tree = data.possibleAttentionTree
      }
    }
  },

  computed: {
    availableCategories() {
      return this.tree.categories
    },
    availablePlans() {
      const categoryId = this.selectedCategoryId

      if (categoryId != -1) {
        return this.tree.plans.filter(p => p.category.id === categoryId)
      } else {
        return []
      }
    },
    availableActions() {
      const planId = this.selectedPlanId

      if (planId != -1) {
        return this.tree.actions.filter(a => a.plan.id === planId)
      } else {
        return []
      }
    }
  },

  watch: {
    selectedCategoryId(val) {
      this.selectedPlanId = -1
    },
    selectedPlanId(val) {
      this.selectedActionId = -1
    },
    selectedActionId(val) {
      this.$emit("update:action", val)
    }
  }
}
</script>

<style scoped>
.control-group {
  margin: 20px 0;
}

.control {
  margin: 10px 0;
}

select {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  height: 35px;
  width: 300px;
  background-color: #f2f2f2;
}
</style>
